import React from 'react';
import './MealPlanResults.css';

const MealPlanResults = ({ results, onClose }) => {
  if (!results) return null;

  const { summary, mealsAdded, preferences, mealPlan } = results;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'long', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const getMealTypeIcon = (mealType) => {
    const icons = {
      breakfast: '🌅',
      lunch: '☀️',
      dinner: '🌙',
      snack: '🍎'
    };
    return icons[mealType] || '🍽️';
  };

  const getMealTypeColor = (mealType) => {
    const colors = {
      breakfast: '#FFB347',
      lunch: '#87CEEB',
      dinner: '#9370DB',
      snack: '#98FB98'
    };
    return colors[mealType] || '#666';
  };

  return (
    <div className="meal-plan-results-overlay">
      <div className="meal-plan-results-modal">
        <div className="results-header">
          <h2>
            <i className="fas fa-check-circle"></i>
            Meal Plan Generated Successfully!
          </h2>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="results-content">
          <div className="summary-section">
            <h3>
              <i className="fas fa-info-circle"></i>
              Summary
            </h3>
            <p className="summary-text">{summary}</p>
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">{mealsAdded}</div>
                <div className="stat-label">Meals Added</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{preferences.weeksToPlan}</div>
                <div className="stat-label">Week{preferences.weeksToPlan > 1 ? 's' : ''} Planned</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{preferences.daysToPlan?.length || 7}</div>
                <div className="stat-label">Days Covered</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{preferences.mealsToConsider?.length || 3}</div>
                <div className="stat-label">Meal Types</div>
              </div>
            </div>
          </div>

          {preferences.dietaryPreferences?.length > 0 && (
            <div className="preferences-section">
              <h3>
                <i className="fas fa-heart"></i>
                Dietary Preferences Applied
              </h3>
              <div className="preference-tags">
                {preferences.dietaryPreferences.map((pref, index) => (
                  <span key={index} className="preference-tag dietary">
                    {pref.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                  </span>
                ))}
              </div>
            </div>
          )}

          {preferences.cuisinePreferences?.length > 0 && (
            <div className="preferences-section">
              <h3>
                <i className="fas fa-globe"></i>
                Cuisine Preferences
              </h3>
              <div className="preference-tags">
                {preferences.cuisinePreferences.map((cuisine, index) => (
                  <span key={index} className="preference-tag cuisine">
                    {cuisine.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                  </span>
                ))}
              </div>
            </div>
          )}

          {mealPlan && mealPlan.mealPlan && (
            <div className="meal-plan-preview">
              <h3>
                <i className="fas fa-calendar-alt"></i>
                Meal Plan Preview
              </h3>
              <div className="meal-plan-grid">
                {mealPlan.mealPlan.slice(0, 7).map((meal, index) => (
                  <div key={index} className="meal-item">
                    <div className="meal-date">
                      {formatDate(meal.date)}
                    </div>
                    <div className="meal-details">
                      <span 
                        className="meal-type"
                        style={{ color: getMealTypeColor(meal.mealType) }}
                      >
                        {getMealTypeIcon(meal.mealType)} {meal.mealType.charAt(0).toUpperCase() + meal.mealType.slice(1)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {mealPlan.mealPlan.length > 7 && (
                <p className="more-meals">
                  And {mealPlan.mealPlan.length - 7} more meals...
                </p>
              )}
            </div>
          )}

          <div className="next-steps">
            <h3>
              <i className="fas fa-lightbulb"></i>
              What's Next?
            </h3>
            <ul>
              <li>
                <i className="fas fa-check"></i>
                Your meal plan has been added to your calendar
              </li>
              <li>
                <i className="fas fa-shopping-cart"></i>
                Use "Select Dates" and "Shop with Instacart" to get ingredients
              </li>
              <li>
                <i className="fas fa-edit"></i>
                Click on any meal to view details or make changes
              </li>
              <li>
                <i className="fas fa-magic"></i>
                Run MealPlanify again anytime to update your plan
              </li>
            </ul>
          </div>
        </div>

        <div className="results-footer">
          <button className="view-meal-plan-btn" onClick={onClose}>
            <i className="fas fa-calendar"></i>
            View My Meal Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default MealPlanResults;
